<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>
          <h3 class="text-neutral mb-2">Acceso a las instalaciones mediante reconocimiento facial.</h3>
          <div class="leading-1 mb-4">
            <p>El reconocimiento facial es una <strong>tecnología segura</strong> que le permitirá acceder a las instalaciones de forma rápida <strong>sin necesidad de presentar ningún documento</strong> en los tornos de entrada.</p>
          </div>
          <base-message-box>
            <template slot="content">
              <p>Antes de empezar le recordamos que es necesario que el dispositivo que vaya a usar para tomar la fotografía disponga de una cámara y se encuentre en un entorno con buenas condiciones de iluminación.</p>
            </template>
          </base-message-box>
        </div>
        <div class="h-10"></div>
        <div class="px-4 sm:px-0">
          <h4 class="font-bold text-xl">Política de privacidad y de protección de datos</h4>
          <p class="text-neutral mb-2">Por favor, lea con atención y si está de acuerdo marque la casilla de verificación e inicie el proceso de reconocimiento biométrico.</p>
        </div>
        <div class="my-4 bg-white rounded-lg p-4 text-sm text-slate-700 prose shadow border border-slate-100">
          <p>Los datos suministrados en el presente formulario serán tratados por el RGCC como responsable habiendo nombrado DPD (dirección electrónica lopd@rgcc.es) y se tratan con la finalidad de verificar su identidad para el acceso a las instalaciones del responsable, la categoría de los datos tratados se encuadra dentro de los identificativos y biohash.</p>
          <p>No se tratan los datos para la elaboración de perfiles, siendo la base de legitimización el artículo 6.1.a) del RGPD consentimiento expreso y libre del interesado, no se prevé la cesión de los datos a ningún tercero ni la transferencia a ningún país fuera de la UE, los datos serán conservados mientras dure su relación con el RGCC y se suprimirán en un máximo de 48 horas desde la finalización de la misma.</p>
          <p>Puede revocar su consentimiento (directamente en este mismo formulario) o ejercer sus derechos de acceso, rectificación, supresión, oposición y limitación a la dirección electrónica del responsable lopd@rgcc.es o a través de su DPD.</p>
          <p>Todos los datos del presente formulario son obligatorios y deben ser veraces.</p>
          <p>Si usted considerara que sus derechos no se han respetado podrá dirigirse a la Agencia Española de Protección de Datos, y Calle Jorge Juan, 6, 28001 - Madrid, como Autoridad Independiente de Control en materia de protección de datos de carácter personal.</p>
          <p>Dispone en esta dirección electrónica información completa sobre el tratamiento de estos datos.</p>
        </div>
      </div>
    </div>
    <base-footer>
      <template slot="ls">
        <el-checkbox v-model="privacy">He leído y acepto la política de privacidad</el-checkbox>
      </template>
      <template slot="rs">
        <base-button mode="primary" custom="w-full md:w-auto" text="Tomar foto" :disabled="!privacy" @click="openModal" />
      </template>
    </base-footer>
    <photo-modal :active.sync="photoModal" @image="onImage" />
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'
import PhotoModal from '@/components/PhotoModal.vue'
import BiometricServices from '@/services/biometrics'
import ImageWrapper from '@/utils/Image'

export default {
  components: { PhotoModal },
  name: 'BiometricConfig',
  mixins: [handleScrollMixin],
  data: function () {
    return {
      privacy: false,
      photoModal: false
    }
  },
  computed: {
    pageTitle: function () {
      return this.$route?.meta?.title
    },
    membership: function () {
      return this.$store.getters['auth/membership']
    },
    isMinor: function () {
      return this.$store.getters['auth/isMinor']
    }
  },
  methods: {
    openModal: function () {
      this.photoModal = true
    },
    close: function () {
      this.photoModal = false
    },
    onImage: function (image) {
      const img = ImageWrapper.removeMimeFromBase64(image)
      this.acceptBiometricProcess(img)
    },
    acceptBiometricProcess: async function (image) {
      try {
        this.$store.commit('app/setLoading', true)
        if (this.isMinor) {
          await BiometricServices.processChild(this.membership, image)
        } else {
          await BiometricServices.process(this.membership, image)
        }
        this.$emit('update')
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
